import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import common from './modules/common'
import tags from './modules/tags'
import logs from './modules/logs'
import customtrans from './modules/customtrans'
import coupon from './modules/coupon'
import article from './modules/article'
import getters from './getters'
import contractManage from './modules/contract-manage'
import evaluate from './modules/evaluate'

Vue.use(Vuex)
const store = new Vuex.Store({
  modules: {
    user,
    common,
    logs,
    tags,
    customtrans,
    coupon,
    article,
    contractManage,
    evaluate
  },
  getters
})

export default store
